const getActionName = suffix => `ADD_${suffix}`

export default {
  add: (storeModule) => ({ commit }, results) =>
    commit(getActionName(storeModule.storeSuffix), results),

  remove: ({ storeSuffix }) => ({ commit }, results) =>
    commit(`REMOVE_${storeSuffix}`, results),
}
